/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_SessionInputs */

const en_verify_session = /** @type {(inputs: Verify_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session`)
};

const es_verify_session = /** @type {(inputs: Verify_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesión`)
};

const fr_verify_session = /** @type {(inputs: Verify_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session`)
};

const de_verify_session = /** @type {(inputs: Verify_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitzung`)
};

const id_verify_session = /** @type {(inputs: Verify_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi`)
};

/** @type {(inputs: Verify_SessionInputs) => LocalizedString} */
const ja_verify_session = en_verify_session;

/** @type {(inputs: Verify_SessionInputs) => LocalizedString} */
const zh_verify_session = en_verify_session;

/** @type {(inputs: Verify_SessionInputs) => LocalizedString} */
const ar_verify_session = en_verify_session;

/** @type {(inputs: Verify_SessionInputs) => LocalizedString} */
const it_verify_session = en_verify_session;

/** @type {(inputs: Verify_SessionInputs) => LocalizedString} */
const ru_verify_session = en_verify_session;

/** @type {(inputs: Verify_SessionInputs) => LocalizedString} */
const pt_verify_session = en_verify_session;

/** @type {(inputs: Verify_SessionInputs) => LocalizedString} */
const ko_verify_session = en_verify_session;

/**
* | output |
* | --- |
* | "Session" |
*
* @param {Verify_SessionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verify_session = /** @type {((inputs?: Verify_SessionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_SessionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verify_session(inputs)
	if (locale === "es") return es_verify_session(inputs)
	if (locale === "fr") return fr_verify_session(inputs)
	if (locale === "de") return de_verify_session(inputs)
	if (locale === "ja") return ja_verify_session(inputs)
	if (locale === "zh") return zh_verify_session(inputs)
	if (locale === "ar") return ar_verify_session(inputs)
	if (locale === "id") return id_verify_session(inputs)
	if (locale === "it") return it_verify_session(inputs)
	if (locale === "ru") return ru_verify_session(inputs)
	if (locale === "pt") return pt_verify_session(inputs)
	return ko_verify_session(inputs)
});